module.exports = __webpack_public_path__ + "static/img/4.bc16f94b.png";